import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux'
import { AnimatePresence } from 'framer-motion';

import { Spinner, Animation } from 'components'
import PaymentMethodInput from './PaymentMethodInput'
import BillingEmailInput from './BillingEmailInput'
import BillingAddressinput from './BillingAddressInput'
import PaymentIntervalInput from './PaymentIntervalInput'

import * as actionCreators from 'store/actions';
import { userContext } from 'context';

const submitButtonStyle = {
    backgroundColor: 'var(--primary-color)',
    boxShadowColor: 'transparent',
    color: 'var(--secondary-color)',
    margin: 0,
    fontWeight: 'bold'
}

const Container = styled.div`
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto auto auto auto;
    border-radius: 5px;
    padding: 0.5rem 0;
`

const Cell = styled.div`
    padding: 1rem;
    border-style: solid;
    border-color: var(--primary-accent-color);
    border-width: ${props => props.borderWidth || '2px'};
    /* border: 1px solid var(--primary-accent-color); */
    border-radius: ${props => props.borderRadius};
    display: flex;
    flex-direction: column;
    align-items: space-around;
    cursor: ${props => props.cursor};
    overflow: hidden;
    background-color: var(--primary-color);
    :hover{
        filter: brightness(var(--brightness));
    }
`

const Title = styled.div`
    font-size: 0.8rem;
    font-weight: bolder;
    text-transform: uppercase;
    margin-bottom: 0.2rem;
`

const Subtitle = styled.div`
    font-size: 0.8rem;
    margin-bottom: 0.5rem;
`

const Input = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    color: var(--secondary-accent-color);
`

const Error = styled.div`
    font-size: 0.8rem;
    color: var(--error-color);
`

const Success = styled.div`
    margin-top: 0.2rem;
    font-size: 0.8rem;
    color: var(--success-color);
`

const Placeholder = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`

const BillingSection = props => {
    const {

    } = props;
    const dispatch = useDispatch()
    const user = useSelector((state) => state.auth.user)
    const paymentMethod = useSelector((state) => state.payment.paymentMethod)
    const customer = useSelector((state) => state.payment.customer)
    const [selection, setSelection] = React.useState(null)
    const [payment, setPayment] = React.useState(null)
    const [showSpinner, setSpinner] = React.useState(true)

    React.useEffect(() => {
        if(user['subscription_plan'] !== userContext.PLANS.PREMIUM){
            setSpinner(false)
        } else {
            !paymentMethod && dispatch(actionCreators.getPaymentMethod(user['uid']))
            !customer && dispatch(actionCreators.getCustomer(user['uid']))
            setTimeout(() => {
                setSpinner(false)
            }, 2000)
        }
        
    }, [])

    if(customer || paymentMethod || !showSpinner){
        const showDetails = paymentMethod && user['subscription_plan'] === userContext.PLANS.PREMIUM & user['subscription_status'] !== 'canceled' 
        let addressBlocks = []
        if(customer){
            Object.values(['line1','line2']).map(key => {
                customer.address[key] && addressBlocks.push(customer.address[key])
            })
            if(customer.address['postal_code']){
                addressBlocks.push(`, Postal code ${customer.address['postal_code']}`)
            }
            customer.address['country'] && addressBlocks.push(`, ${customer.address['country']}`)
        }
        return(
            <Animation animation='expand'>
                <Container>
                    {/* Credit card */}
                    <Cell cursor='pointer' borderRadius={'5px 5px 0 0'} onClick={() => {paymentMethod && dispatch(actionCreators.setModal(<PaymentMethodInput/>))}}>
                        <Title>Payment Method</Title>
                        <AnimatePresence>
                            {selection !== 'PAYMENT_METHOD' ? 
                            <Input>{paymentMethod ? `Card ending with ${paymentMethod.card['last4']}` : '-'}</Input>
                            : <Animation animation='expand'>
                                <div>input here</div>
                            </Animation>}
                        </AnimatePresence>
                    </Cell>
        
                    {/* Payment interval */}
                    <Cell cursor='pointer' onClick={() => selection !== 'PAYMENT_INTERVAL' && showDetails && setSelection('PAYMENT_INTERVAL')} borderWidth='0 2px 2px 2px'>
                        <Title>Payment Interval</Title>
                        <AnimatePresence>
                            {selection !== 'PAYMENT_INTERVAL' ? 
                            <Input> {user['subscription_status'] == 'canceled'  ? '-' : user['subscription_frequency'] === 'MONTHLY' ? 'Monthly' : 'Yearly'} </Input>
                            : <Animation animation='expand'>
                                <PaymentIntervalInput onClose={() => setSelection(null)}/>
                            </Animation>}
                        </AnimatePresence>
                    </Cell>
        
                    {/* Billing email */}
                    <Cell cursor='pointer' onClick={() => selection !== 'BILLING_EMAIL' && customer && setSelection('BILLING_EMAIL')} borderWidth='0 2px 2px 2px'>
                        <Title>Billing Email</Title>
                        <AnimatePresence>
                            {selection !== 'BILLING_EMAIL' ? 
                            <Input>{!customer ? '-' : customer['email'] || '-'}</Input>
                            : <Animation animation='expand'>
                                <BillingEmailInput email={customer['email']} onClose={() => setSelection(null)}/>
                            </Animation>}
                        </AnimatePresence>
                    </Cell>
        
                    {/* Billing addres */}
                    <Cell cursor='pointer' borderRadius={'0 0 5px 5px'} onClick={() => selection !== 'BILLING_ADDRESS' && customer && setSelection('BILLING_ADDRESS')} borderWidth='0 2px 2px 2px'>
                        <Title>Billing Address</Title>
                        <AnimatePresence>
                            {selection !== 'BILLING_ADDRESS' ? 
                            <Input>{addressBlocks.length > 0 ? addressBlocks.join(' ') : '-'}</Input>
                            : <Animation animation='expand'>
                                <BillingAddressinput address={customer['address']} onClose={() => setSelection(null)}/>
                            </Animation>}
                        </AnimatePresence>
                    </Cell>
                    
                </Container>
            </Animation>
        )
    } else {
        return (
            <Container>
                <Placeholder>
                    <div style={{fontWeight: 'bold', fontSize: '0.8rem', margin: '0.5rem'}}>Getting billing info</div>
                    <Spinner/>
                </Placeholder>
            </Container>
        )
    }
    
}

export default BillingSection